import { render, staticRenderFns } from "./make_nutrition.vue?vue&type=template&id=72985ed8&scoped=true&"
import script from "./make_nutrition.vue?vue&type=script&lang=js&"
export * from "./make_nutrition.vue?vue&type=script&lang=js&"
import style0 from "./make_nutrition.vue?vue&type=style&index=0&id=72985ed8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72985ed8",
  null
  
)

export default component.exports